import type { AllRouteEndpoints } from "../routeTypes";

export const postApiCalculatedAttributesAppGroupIdArchiveCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_attributes/:app_group_id",
  "/api/calculated_attributes/:id/:app_group_id",
];
